import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './globals.css'
import { AppRouter } from './AppRouter'
import { QueryProvider } from './providers/QueryProvider'
import { I18nProvider } from './providers/I18nProvider'
import { ThemeProvider } from './providers/ThemeProvider'
import { PageHeaderProvider } from './providers/PageHeaderProvider'
import { SplashProvider } from './providers/SplashProvider'
import { Toaster } from './components/toast/Toaster'
import { initConsoleBanner } from '@swim/ui'
import { ConsentProvider } from './providers/ConsentProvider'

initConsoleBanner()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/*
      Provider order matters:
      1. HelmetProvider — outermost, manages <head> tags per route
      2. I18nProvider   — must wrap Suspense boundary for all children
      3. QueryProvider  — React Query context for all data fetching
      4. BrowserRouter  — routing context
      5. SplashProvider — controls splash overlay on top of the full app
      Toaster is outside providers — toasts survive route changes
    */}
    <HelmetProvider>
      <ThemeProvider>
        <ConsentProvider>
          <I18nProvider>
            <QueryProvider>
              <BrowserRouter>
                <PageHeaderProvider>
                  <SplashProvider>
                    <AppRouter />
                  </SplashProvider>
                </PageHeaderProvider>
              </BrowserRouter>
            </QueryProvider>
          </I18nProvider>
          {/* Inside ThemeProvider so Toaster can read theme and apply SWIM dark/light styles */}
          <Toaster />
        </ConsentProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
)
